import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useFiles } from 'client/store'
import filesSelectors from 'client/store/files/filesSelectors'
import { EntityProps } from 'client/types'
import CommonImage from 'common/components/entities/ImageNew'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import React from 'react'
import { getImageSourceResult } from 'src/shared/utils/get-image-sources'
import BaseEntityNew from '../../core/BaseEntity/BaseEntityNew'

const demoImageSrc = `${process.env.EDITOR_ASSETS_HOST}/assets/images/image_placeholder.png`

const Image = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ImageInterface>) => {
  const { isMobile } = useDeviceModeContext()
  const file = useFiles(state =>
    filesSelectors.getFileById(state, entity.fileId),
  )
  const mobileFile = useFiles(state =>
    filesSelectors.getFileById(state, entity.mobileFileId),
  )
  const { imageSrc, mobileImageSrc } = getImageSourceResult({
    entity,
    desktopFilePath: file?.path,
    mobileFilePath: mobileFile?.path,
    fallbackDesktopSrc: demoImageSrc,
  })
  const resolvedSrc =
    isMobile && mobileImageSrc !== undefined ? mobileImageSrc : imageSrc
  const resolvedRatio = isMobile ? entity.mobileRatio : entity.ratio

  return (
    <BaseEntityNew
      entity={entity}
      isSaveAllowed={Boolean(file)}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      flex
      flexColumn
    >
      <CommonImage
        background={entity.background}
        mobileBackground={entity.mobileBackground}
        attrId={entity.htmlAttrId}
        src={resolvedSrc}
        alt={entity.alt}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        delay={entity.delay}
        blur={entity.blur}
        ratio={resolvedRatio}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
      />
    </BaseEntityNew>
  )
}

export default Image
